<div
  role="dialog"
  aria-labelledby="modalResponseFastMessage"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalResponseFastMessage">
          {{ 'shared.bottomSheetResponseFast.title' | translate }}
          <br />
          <span class="text-muted fw-normal font-14"
            >{{ 'shared.bottomSheetResponseFast.subtitle' | translate }}</span
          >
        </h4>
      </div>
      <div class="modal-body custom-scroll-bar">
        <div class="row">
          <div class="col-sm-9 input-trend-search">
            <input
              class="form-control w-100"
              type="search"
              #searchBox
              (keyup)="search(searchBox.value)"
              [placeholder]="'shared.bottomSheetResponseFast.searchPlaceholder' | translate"
            />
            <span class="mdi mdi-magnify search-icon"></span>
          </div>
          <div class="col-sm-3 trend-button">
            <button
              type="submit"
              [matMenuTriggerFor]="menu"
              class="btn btn-primary dropdown-toggle"
            >
              {{ 'shared.bottomSheetResponseFast.categories' | translate }} <span class="caret"></span>
            </button>
          </div>
          <mat-menu #menu class="menu-content">
            <button (click)="selectedCategory('')" mat-menu-item>{{ 'shared.bottomSheetResponseFast.all' | translate }}</button>
            @for (category of listCategory; track $index) {
            <button (click)="selectedCategory(category.name)" mat-menu-item>
              {{ category ? category.name : "" }}
            </button>
            }
          </mat-menu>
        </div>

        @if(loadingSpinner$ | async) {
        <loading-component />
        }
        @if (!(loadingSpinner$ | async) && pager.total > 0) {
          <div class="table-responsive">
            <table class="table table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">{{ 'shared.bottomSheetResponseFast.columnName' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.bottomSheetResponseFast.columnCategory' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.bottomSheetResponseFast.columnMessage' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.bottomSheetResponseFast.columnType' | translate }}</th>
                  <th class="sr-only custom-button-select">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                @for (item of pager.list; track $index) {
                <tr>
                  <td>
                    {{ item.name || "-" }}
                  </td>
                  <td>
                    {{ item.category ? item.category.name : "N/A" }}
                  </td>
                  <td>
                    {{ item.message | truncate : 50 }}
                  </td>
                  <td>
                    {{ getFileExtension(item) }}
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-dark"
                      (click)="selectedResponseFast(item)"
                    >
                      <i class="ri-check-line"></i>
                      {{ 'shared.bottomSheetResponseFast.selectButton' | translate }}
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
          @if(pager.total > pager.perPage) {
            <paginator
              class="flex justify-content-center mt-3 mb-3"
              [pager]="pager"
              (onPager)="loadPage($event)"
            />
          }
        }

        @if (pager.total == 0) {
          <empty-records-component
            [message]="'shared.bottomSheetResponseFast.emptyMessage' | translate"
            [subMessage]="'shared.bottomSheetResponseFast.emptySubMessage' | translate"
            [icon]="'mdi mdi-alert-circle-outline'"
          />
        }
      </div>
    </div>
  </div>
</div>
